import * as React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { useAuth0 } from '@auth0/auth0-react'
import { useTranslation } from 'react-i18next'

const VendorLogin: React.FC = () => {
  const { loginWithRedirect } = useAuth0()
  const { t } = useTranslation()

  return (
    <Box
      display="grid"
      sx={{
        flex: 1,
        gridTemplateColumns: {
          xs: '1fr 0px',
          md: '550px 1fr',
          lg: '800px 1fr'
        }
      }}
    >
      <Box
        display="flex"
        sx={{
          justifyContent: 'flex-start',
          alignItems: 'center',
          flexDirection: 'column',
          px: { xs: 3, md: 9 },
          mt: 4
        }}
      >
        <Box sx={{ mb: 4, alignSelf: 'flex-end' }}>
          <img src={'/images/thinger-hankinta-logo.png'} alt="Thinger logo" />
        </Box>
        <Box sx={{ backgroundColor: 'grey.100', p: 3, borderRadius: 3, width: '100%' }}>
          <Typography variant="h2" sx={{ fontSize: '32px' }}>
            {t('sign-in-to-vendor-view')}
          </Typography>
          <Typography color="textSecondary" sx={{ maxWidth: { sm: '65ch', md: '85ch' }, mt: 3 }}>
            {t('sign-in-text-1')}
          </Typography>
          <Button sx={{ mt: 3 }} variant="contained" onClick={() => loginWithRedirect()}>
            {t('sign-in-or-register')}
          </Button>
        </Box>
        <Box sx={{ mb: 2, px: 3 }}>
          <Typography variant="h6" sx={{ mt: 5 }}>
            {t('why-should-you-register')}
          </Typography>
          <Typography color="textSecondary" sx={{ mt: 3, fontSize: '14px' }}>
            {t('sign-in-text-2')}
          </Typography>
          <Typography color="textSecondary" sx={{ mt: 3, fontSize: '14px' }}>
            {t('sign-in-text-3')}
          </Typography>
          <Typography color="textSecondary" sx={{ mt: 3, fontSize: '14px' }}>
            {t('sign-in-text-4')}
          </Typography>
          <Typography color="textSecondary" sx={{ fontSize: '14px' }}>
            {t('sign-in-list-1')}
          </Typography>
          <Typography color="textSecondary" sx={{ fontSize: '14px' }}>
            {t('sign-in-list-2')}
          </Typography>
          <Typography color="textSecondary" sx={{ fontSize: '14px' }}>
            {t('sign-in-list-3')}
          </Typography>
          <Typography color="textSecondary" sx={{ fontSize: '14px' }}>
            {t('sign-in-list-4')}
          </Typography>
          <Typography color="textSecondary" sx={{ fontSize: '14px' }}>
            {t('sign-in-list-5')}
          </Typography>
          <Typography color="textSecondary" sx={{ mt: 3, fontSize: '14px' }}>
            {t('sign-in-text-5')}
          </Typography>
          <Typography color="textSecondary" sx={{ mt: 3, fontSize: '14px' }}>
            {t('sign-in-text-6')}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          backgroundImage: 'url(/images/login-bg.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      ></Box>
    </Box>
  )
}

export default VendorLogin
